import PetIcon from '@mui/icons-material/Pets'
import PetEdit from './PetEdit'
import PetList from './PetList'
import PetShow from './PetShow'

export default {
  list: PetList,
  show: PetShow,
  edit: PetEdit,
  icon: PetIcon,
  recordRepresentation: 'xx',
}
